import React from 'react'

const Editadmin = () => {
  return (
    <div>Editadmin</div>
  )
}

export default Editadmin